import type { LoginTab } from './LoginTabs';

interface LoginAccountPromptProps {
  activeTab: LoginTab;
  onSelectTab: (tab: LoginTab) => void;
}

/** "Don't have an account? / Already have an account?" footer under the card. */
export const LoginAccountPrompt = ({ activeTab, onSelectTab }: LoginAccountPromptProps) => (
  <div className="mt-6 text-center text-sm text-gray-600">
    {activeTab === 'signin' ? (
      <p>
        Don't have an account?{' '}
        <button
          onClick={() => onSelectTab('signup')}
          className="text-primary-600 hover:text-primary-700 hover:underline font-medium"
        >
          Create one
        </button>
      </p>
    ) : (
      <p>
        Already have an account?{' '}
        <button
          onClick={() => onSelectTab('signin')}
          className="text-primary-600 hover:text-primary-700 hover:underline font-medium"
        >
          Sign in
        </button>
      </p>
    )}
  </div>
);
